export function Loading({ message = 'Loading...' }) {
  return (
    <div className="empty-state" aria-live="polite">
      <p className="text-muted">{message}</p>
    </div>
  );
}
